module.exports = __webpack_public_path__ + "img/ubicacion.7bc496f3.svg";